//node_modules
import React, { FunctionComponent, Fragment } from "react";
import { NextSeo, SocialProfileJsonLd, LocalBusinessJsonLd } from "next-seo";

//helpers
import getImageLoaderAbsoluteSrc from "@adjust/website/libs/helper/getImageLoaderAbsoluteSrc";
import getWebsiteUrl from "@adjust/website/libs/helper/getWebsiteUrl";

//constants
import { FACEBOOK_LINK, INSTAGRAM_LINK } from "libs/constants";

//hooks
import useCanonical from "@adjust/src/hooks/useCanonical";

const title = "Adjust to the Good Life Travel | Raleigh Based Travel Agency";
const description = "I am a Raleigh, NC based travel agent who specializes in helping families and couples find and experience the most amazing dream vacations.";
const src = getImageLoaderAbsoluteSrc("/images/5f7cbe2dc628e35784b204b6d16dba89.png", 1200);

const MetaComponent: FunctionComponent = () => {
  const canonical = useCanonical();

  return (
    <Fragment>
      <NextSeo
        title={title}
        description={description}
        canonical={canonical}
        noindex={false}
        nofollow={false}
        openGraph={{
          type: "website",
          siteName: "Adjust to the Good Life Travel",
          url: canonical,
          title: title,
          description: description,
          images: [
            {
              url: src,
            },
          ],
        }}
        twitter={{
          cardType: "summary_large_image",
        }}
      />
      <LocalBusinessJsonLd
        id={"https://www.adjusttothegoodlifetravel.com/"}
        type="TravelAgency"
        description={description}
        address={undefined}
        name="Adjust to the Good Life Travel"
        telephone="+1-919-810-3743"
        openingHours={[
          { "@type": "OpeningHoursSpecification", dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], opens: "09:00", closes: "20:00" },
          { "@type": "OpeningHoursSpecification", dayOfWeek: ["Sunday"], opens: "13:00", closes: "18:00" },
        ]}
      />
      <SocialProfileJsonLd keyOverride="json-socials" type="Organization" name="Adjust to the Good Life Travel" url={getWebsiteUrl("/")} sameAs={[FACEBOOK_LINK, INSTAGRAM_LINK]} />
    </Fragment>
  );
};

export default React.memo(MetaComponent);
